import React, { useContext } from 'react';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import { useHistory } from 'react-router-dom';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangeSubCategoryPositionContext,
	IChangeSubCategoryPositionContext,
} from '../../../changeSubCategoryPositionState/changeSubCategoryPositionContext';
import { updateSubCategoryPositionsV2 } from 'backend/subcategories';
import Text from 'components/Text/Text';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

export const ModalWindows: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		typeOfModalWindow,
		positionsData,
		selectedRestaurant,
		IDSelectedCategory,
		selectedAdditionalRestaurants,
	} = useContext<IChangeSubCategoryPositionContext>(ChangeSubCategoryPositionContext);
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const history = useHistory();
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const restaurantsToApplyChanges = selectedRestaurant ? [selectedRestaurant, ...selectedAdditionalRestaurants] : [];

	const handleRedirect = () => {
		history.push('/menu-v2/subcategory');
	};

	const handleConfirm = async () => {
		if (positionsData && selectedRestaurant && IDSelectedCategory) {
			try {
				const restaurantIds = [selectedRestaurant.id, ...selectedAdditionalRestaurants.map((el) => el.id)];
				const subCategoryIds = positionsData.map((el) => el.id);
				showLoader();
				await updateSubCategoryPositionsV2({
					restaurantIds,
					categoryId: IDSelectedCategory,
					subCategoryIds,
				});
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			{typeOfModalWindow === 'toConfirmFieldsClearing' && (
				<ModalToConfirm
					onConsentEvent={handleRedirect}
					onFailureEvent={() => changeTypeOfModalWindow(null)}
					isVisible={true}
					description="cancelSaveInfo"
				/>
			)}
			{typeOfModalWindow === 'toConfirmSave' && (
				<ModalToConfirm
					onConsentEvent={handleConfirm}
					onFailureEvent={() => changeTypeOfModalWindow(null)}
					isVisible={true}
					description="saveChangeOnRestaurants"
					typeOfInfoIcon="withoutIcon"
					additionalContent={
						!!restaurantsToApplyChanges?.length && (
							<div className={style.itemsList}>
								{restaurantsToApplyChanges.map((el) => (
									<Text
										key={el.id}
										translationKey={el.name}
										theme="secondaryLight"
										size="l"
										weight="bold"
									/>
								))}
							</div>
						)
					}
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={() => changeTypeOfModalWindow(null)}
					isVisible={true}
					description="savedSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError
					onConsentEvent={() => changeTypeOfModalWindow(null)}
					isVisible={true}
					description="errorWhileSaving"
				/>
			)}
		</div>
	);
};
